
import React, { useEffect } from 'react';
import useWindowSize from './utils/useWindowSize';

const LoadingPage: React.FC = () => {
  const { width } = useWindowSize();

  useEffect(() => {
    const loadingBar = document.querySelector('.loading-bar') as HTMLDivElement;
    let widthProgress = 0;
    const interval = setInterval(() => {
      if (widthProgress >= 100) {
        clearInterval(interval);
      } else {
        widthProgress += 1;
        if (loadingBar) loadingBar.style.width = `${widthProgress}%`;
      }
    }, 30);

    return () => clearInterval(interval);
  }, []);

  const isMobile = width <= 768;
  const bgImage = isMobile ? '/assets/mb_loadingBg.png' : '/assets/loadingBg.png';

  return (
    <div
      className="relative w-full h-screen flex items-center justify-center overflow-hidden"
      style={{ backgroundImage: `url(${bgImage})`, backgroundSize: '100% 100%', backgroundPosition: 'center' }}
    >
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
        <img
          src={'/assets/bingo-cards.png'}
          alt="bingo cards"
          className={` ${width <=280 ? 'w-60 h-60' : 'w-100 h-100 md:w-150 md:h-150 lg:w-150 lg:h-150'} `}
        />
        <p className="text-white  text-[16px] md:text-[30px] font-bold -mt-5  font-kadwa">Loading...</p>
        <div
          className={`${width <=280 ? 'w-[200px]' : 'md:w-[300px] w-full lg:w-[500px] h-[40px]'}  bg-[#070B7B] mt-2 rounded-full border-4 border-[#F79B14] overflow-hidden`}
          style={{
            background: '#070B7B', 
          }}
        >
          <div
            className="loading-bar h-[35px] rounded-full transition-all duration-300 ease-in-out"
            style={{
              width: '0%',
              backgroundImage: `url(${'/assets/red_Loading.png'})`, 
              backgroundSize: 'cover', 
              backgroundPosition: 'center',
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;